import { put, call } from 'redux-saga/effects';
import Creators from '../state/AppRedux';
import { questionsService } from '../services/questionsService';

/**
 * A saga can contain multiple functions.
 *
 * This example saga contains only one to fetch the weather temperature.
 * Feel free to remove it.
 */
export function * getAllQuestions (params) {
	// console.log('getAllQuestions: Saga: ', params);
	// Dispatch a redux action using `put()`
	// @see https://redux-saga.js.org/docs/basics/DispatchingActions.html
	yield put(Creators.fetchingQuestions());
	
	// Fetch the temperature from an API
	let questions = null;
	try {
		questions = yield call(questionsService.getQuestions, params);
	} catch (e) {
		//bugsnag.notify(e)
	}
	// console.log('getAllQuestions: Saga: Fetched ', questions);
	if (questions && questions.status === 200) {
		console.log(questions);
		yield put(Creators.questionsFetchedSuccessfully(questions.data.response, params.interventionType));
	} else {
		// console.log('getAllQuestions: Saga: Fetched, error occured');
		if (questions.data !== null && typeof questions.data === 'object') { // for request timeout logging
			if (questions.data.code === 412) {
				yield put(Creators.resetAuthToken(true));
				//params.navigation.navigate('LoginScreen', { redirectMessage: 'Please login to continue.', replace: true })
			} else {
				//bugsnag.notify(questions)
				yield put(Creators.questionsFetchFailed(questions.data.response));
			}
		} else { // log timed out requests
			//bugsnag.notify(questions)
			yield put(Creators.questionsFetchFailed(questions.data));
		}
	}
}
